import { useEffect, useRef } from "react"

// ** Helpers
import { cn } from "@pma/utils/helpers"

// ** Custom Hooks
import useTranslator from "@pma/hooks/use-translator"

export const SelectionCheckbox = ({
  checked,
  indeterminate = false,
  onChange,
  className,
  disabled = false,
}: {
  checked: boolean
  indeterminate?: boolean
  onChange?: (checked: boolean) => void
  className?: string
  disabled?: boolean
}) => {
  const { locale } = useTranslator()
  const isHebrew = locale === "he"
  const checkboxRef = useRef<HTMLInputElement>(null)

  useEffect(() => {
    if (checkboxRef.current) {
      checkboxRef.current.indeterminate = indeterminate && !checked
    }
  }, [indeterminate, checked])

  return (
    <input
      ref={checkboxRef}
      type='checkbox'
      checked={checked}
      onChange={(e) => onChange?.(e.target.checked)}
      disabled={disabled}
      className={cn(
        "h-5 w-5 cursor-pointer appearance-none rounded-md border-[1px] border-neutral-300 bg-white checked:border-black checked:bg-black checked:before:block checked:before:h-3 checked:before:w-2 checked:before:translate-y-[0px] checked:before:rotate-45 checked:before:border-b-2 checked:before:border-r-2 checked:before:border-white checked:before:content-[''] indeterminate:border-black indeterminate:bg-black indeterminate:before:block indeterminate:before:h-0 indeterminate:before:w-2.5 indeterminate:before:translate-y-[8px] indeterminate:before:border-b-2 indeterminate:before:border-white indeterminate:before:content-['']",
        isHebrew ? "checked:before:-translate-x-[4px] indeterminate:before:-translate-x-[4px]" : "checked:before:translate-x-[5px] indeterminate:before:translate-x-[4px]",
        className,
      )}
    />
  )
}
